import React, { useEffect, useState } from "react";
import moment from "moment";

const labels = {
  title: {
    da: "Planlæg din fisketur",
    en: "Plan your fishingtrip",
    de: "Planen Sie Ihre Angeltour",
  },
  days: {
    da: ["Man", "Tir", "Ons", "Tor", "Fre", "Lør", "Søn"],
    en: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    de: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
  },
};

let days = []; //sæt navne på dage:
for (let i = 0, j = 0; i < 3; i++) {
  i === 0 && parseInt(moment().format("HH")) >= 21 && j++; //fjern i dag, hvis tid over 21
  let dayNr = moment()
    .add(j, "days")
    .day();
  dayNr = dayNr === 0 ? 6 : dayNr - 1;
  let name = {
    da: j === 0 ? "I dag" : labels.days.da[dayNr],
    en: j === 0 ? "Today" : labels.days.en[dayNr],
    de: j === 0 ? "Heute" : labels.days.de[dayNr],
  };

  days[i] = {
    moment: moment().add(j, "days"),
    name: name,
  };
  j++;
}

/*
 * This is a simple component that allows the user to pick a day and a time
 */

const PickContainer = (props) => {
  const [selectedDayIndex, setSelectedDayIndex] = useState(0);
  const [selectedTimeIndex, setSelectedTimeIndex] = useState(0);

  const selectedDay = days[selectedDayIndex];
  const dayHours = [6, 9, 12, 15, 18, 21].filter((h) => {
    const isToday = selectedDayIndex === 0;

    // Don't show hours that are more than 48 hours from now
    const hoursFromNow = selectedDay.moment
      .clone()
      .hour(h)
      .diff(moment(), "hours");
    if (hoursFromNow > 48) return false;

    //Dont show hours that are in the past
    if (!isToday) return true;
    const currentHour = parseInt(moment().format("HH"));
    return h + 2 > currentHour;
  });
  const selectedTime = dayHours[selectedTimeIndex];

  const handleSelectDay = (index: number) => {
    setSelectedDayIndex(index);
    setSelectedTimeIndex(0);
  };

  const { onChange } = props;
  useEffect(() => {
    onChange(selectedDay.moment, selectedTime);
  }, [selectedDayIndex, selectedTime, onChange]);

  return (
    <div style={{ width: "250px" }} className="planner weatherDayContainer">
      <div className="header">{labels.title[props.language]}</div>
      <div className="body">
        <div className="daysContainer">
          <div className="weatherDay">
            {days.map((day, i) => (
              <div
                key={i}
                className={selectedDayIndex === i ? "day selected" : "day"}
                onClick={() => handleSelectDay(i)}
              >
                <span>{day.name[props.language]}</span>
              </div>
            ))}
          </div>
          <div className="slidecontainer">
            <div className="range">
              <input
                type="range"
                min={dayHours[0]}
                max={dayHours[dayHours.length - 1]}
                value={selectedTime}
                style={{
                  width: dayHours.length * 40 + "px",
                  left: "50%",
                  marginLeft: "-" + (dayHours.length * 40) / 2 + "px",
                }}
                onChange={(value) => {
                  setSelectedTimeIndex(
                    dayHours.indexOf(parseInt(value.target.value))
                  );
                }}
                className="slider"
                id="myRange"
                step="3"
              />
            </div>
            <ul
              className="range-labels"
              style={{
                width: dayHours.length * 40 + "px",
                left: "50%",
                marginLeft: "-" + (dayHours.length * 40) / 2 + "px",
              }}
            >
              {dayHours.map((hour, i) => (
                <li key={i} className="active selected">
                  {hour}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PickContainer;
